import React from "react"
import Grid from "@bappweb/grid"
import Block from "@bappweb/block"
import SmsForm from "./smsform"
import LandingHeader from "./landingheader"
import QrCode from "./qrcode"
import Link from "@bappweb/link"
import Advantage from "./advantage"

const Landing = () => {
  return (
    <Block type="section" className="download-app" id="landing-page-wrapper">
      <LandingHeader />
      <Grid type="div" className="download-app-container container">
        <Block className="sms">
          <SmsForm />
        </Block>
        <Block className="qr">
          <QrCode />
          <Link className="qr-tab-button" text={"Nasıl Akbanklı Olurum?"}
            target="_blank"
            href={"https://www.akbank.com/tr-tr/genel/nasil-kullanirim/Sayfalar/default.aspx#Bireysel-1-50"} />
          <Link className="qr-tab-button" text={"Nasıl Şifre Alırım?"}
            target="_blank"
            href={"https://www.akbank.com/tr-tr/genel/nasil-kullanirim/Sayfalar/default.aspx#Bireysel-1-9"} />
        </Block>
        <Block className="advantage">
          <Advantage />
        </Block>
      </Grid>
    </Block>
  )
}

export default Landing
